/* eslint-disable max-lines, max-len */

export const BASE_URL = '/lcm/lcops';

export const LOCKER_BASE_URL = '/lcm/locker';

export const REQUEST_BASE_URL = '/lcm/request';

export const DATACENTERS_URL = `${BASE_URL}/api/datacenters`;

export const PASSWORDS_URL = `${LOCKER_BASE_URL}/api/passwords`;

export const REGIONS_URL = (dataCenterVmid: string) =>
  `${BASE_URL}/api/datacenters/${dataCenterVmid}/regions`;

export const DATACENTER_URL = (dataCenterVmid: string) =>
  `${BASE_URL}/api/datacenters/${dataCenterVmid}`;

export const ZONES_URL = (dataCenterVmid: string, regionName: string) =>
  `${BASE_URL}/api/datacenters/${dataCenterVmid}/regions/${regionName}/zones`;

export const VCENTERS_URL = (
  dataCenterVmid: string,
  regionName: string,
  zoneName: string
) =>
  `${BASE_URL}/api/datacenters/${dataCenterVmid}/regions/${regionName}/zones/${zoneName}/vCenters`;

export const VALIDATE_VCENTERS_URL = (
  dataCenterVmid: string,
  regionName: string,
  zoneName: string
) =>
  `${BASE_URL}/api/datacenters/${dataCenterVmid}/regions/${regionName}/zones/${zoneName}/validatevCenters`;

export const GET_DATACENTER_ENVIRONMENTS_URL = (dataCenterVmid: string) =>
  `${BASE_URL}/api/datacenters/${dataCenterVmid}/environments`;

export const ADD_BULK_VCENTERS_URL = (
  dataCenterVmid: string,
  regionName: string,
  zoneName: string
) =>
  `${BASE_URL}/api/datacenters/${dataCenterVmid}/regions/${regionName}/zones/${zoneName}/importvCenters`;

export const VCENTERS_VALIDATE_URL = (
  dataCenterVmid: string,
  regionName: string,
  zoneName: string
) =>
  `${BASE_URL}/api/datacenters/${dataCenterVmid}/regions/${regionName}/zones/${zoneName}/vCenters/lcm-vc/validate`;

export const VCENTERS_DATA_COLLECTION_URL = (
  dataCenterVmid: string,
  regionName: string,
  zoneName: string,
  vCenterName: string
) =>
  `${BASE_URL}/api/datacenters/${dataCenterVmid}/regions/${regionName}/zones/${zoneName}/vCenters/${vCenterName}/datacollection`;

export const VCENTER_DATA_URL = (
  dataCenterVmid: string,
  regionName: string,
  zoneName: string,
  vCenterName: string
) =>
  `${BASE_URL}/api/datacenters/${dataCenterVmid}/regions/${regionName}/zones/${zoneName}/vCenters/${vCenterName}`;

export const GET_PRODUCTS_URL = `${BASE_URL}/api/policy/products`;

export const GET_GEOLOCATION_URL = (pattern: string) =>
  `${BASE_URL}/api/geolocation/search/${pattern}`;

export const ENVIRONMENT_URL = `${BASE_URL}/api/environments`;

export const GET_ENVIRONMENT_BY_ID = (environmentId: string) =>
  `${BASE_URL}/api/environments/data/${environmentId}`;

export const PREVALIDATE_JSON_SPEC_URL = `${BASE_URL}/api/environments/import/prevalidate`;

export const SCALE_OUT_URL = (environmentId: string, productId: string) =>
  `${BASE_URL}/api/environments/${environmentId}/products/${productId}/nodes`;

export const ORGANIC_GROWTH_URL = (environmentId: string) =>
  `${BASE_URL}/api/environments/${environmentId}/addproducts`;

export const GET_ENVIRONMENT_STATE_URL = (requestId: string) =>
  `${BASE_URL}/api/${requestId}/ui`;

export const GET_PENDING_ENVIRONMENT_URL = `${BASE_URL}/api/environments/pendingrequests`;

export const GET_ALL_ENVIRONMENT_URL = `${BASE_URL}/api/environments/requests`;

export const GET_INFRA_METADATA_URL = `${BASE_URL}/api/uimetadata/environment/infra`;

export const GET_PRODUCT_PROPERTIES_METADATA_URL = `${BASE_URL}/api/uimetadata/productProperties`;

export const GET_IMPORT_PROPERTIES_METADATA_URL = (product: string) =>
  `${BASE_URL}/api/uimetadata/products/${product}/import`;

export const GET_PRODUCT_METADATA_URL = `${BASE_URL}/api/uimetadata/products/nodes`;

export const GET_PRODUCT_CLUSTER_VIP_METADATA_URL = (
  product: string,
  version: string
) =>
  `${BASE_URL}/api/uimetadata/products/${product}/version/${version}/clustervip`;

export const GET_NODES_CARDINALITY_URL = (product: string, version: string) =>
  `${BASE_URL}/api/uimetadata/products/${product}/version/${version}/cardinality`;

export const GET_NODE_DEFAULT_PROPERTIES_METADATA_URL = (
  product: string,
  nodeType: string
) => `${BASE_URL}/api/uimetadata/products/${product}/node/${nodeType}/default`;

export const GET_NODE_ADVANCED_PROPERTIES_METADATA_URL = (
  product: string,
  nodeType: string
) => `${BASE_URL}/api/uimetadata/products/${product}/node/${nodeType}/advance`;

export const GET_LICENSE_ALIASES_URL = `${LOCKER_BASE_URL}/api/licenses`;

export const GET_LICENSE_BY_VMID_URL = (vmid: string) =>
  `${LOCKER_BASE_URL}/api/licenses/detail/${vmid}`;

export const GET_LICENSE_BY_ALIAS_URL = (alias: string) =>
  `${LOCKER_BASE_URL}/api/licenses/alias/${alias}`;

export const VALIDATE_LICENSE_ASSOCIATION_URL = (
  envId: string,
  productName: string
) => `${LOCKER_BASE_URL}/api/license/validReplace/${envId}/${productName}`;

export const GET_CERTIFICATE_ALIASES_URL = `${LOCKER_BASE_URL}/api/certificates/list/vmids`;

export const GET_PASSWORD_ALIASES_URL = `${LOCKER_BASE_URL}/api/passwords/list/vmids`;

export const GET_PASSWORD_BY_VMID_URL = (vmid: string) =>
  `${LOCKER_BASE_URL}/api/passwords/detail/${vmid}`;

export const GET_PRODUCT_CERTIFICATE_URL = (
  productId: string,
  environmentId: string,
  componentName: string
) =>
  `${BASE_URL}/api/environments/${environmentId}/products/${productId}/certificate?component=${componentName}`;

export const GET_CERTIFICATE_BY_VMID_URL = (vmid: string) =>
  `${LOCKER_BASE_URL}/api/certificates/detail/${vmid}`;

export const PRODUCT_REPLACE_CERTIFICATE_URL = (
  productId: string,
  environmentId: string,
  tenantId?: string
) => {
  const searchParams = new URLSearchParams();
  if (['vro', 'vssc'].includes(productId) && tenantId) {
    searchParams.append('tenantId', tenantId);
  }
  return `${BASE_URL}/api/environments/${environmentId}/products/${productId}/updatecertificate?${searchParams.toString()}`;
};

export const PRODUCT_REPLACE_LICENSE_URL = (
  productId: string,
  environmentId: string
) =>
  `${BASE_URL}/api/environments/${environmentId}/products/${productId}/replacelicense`;

export const PRODUCT_REPLACE_CERTIFICATE_PRE_CHECK_URL = (
  productId: string,
  environmentId: string,
  tenantId?: string
) => {
  const searchParams = new URLSearchParams();
  if (['vro', 'vssc'].includes(productId) && tenantId) {
    searchParams.append('tenantId', tenantId);
  }
  return `${BASE_URL}/api/environments/${environmentId}/products/${productId}/updatecertificate/prevalidate?${searchParams.toString()}`;
};

export const DOWNLOAD_ENVIRONMENT_LOGS_URL = (environmentId: string) =>
  `${BASE_URL}/api/environments/${environmentId}/logs`;

export const DELETE_ENVIRONMENT_LOGS_URL = (
  environmentId: string,
  logBundlePaths: string,
  productId?: string,
  tenantId?: string
) => {
  const searchParams = new URLSearchParams();
  searchParams.append('logBundlePaths', logBundlePaths);
  if (productId) {
    searchParams.append('productId', productId);
    if (['vro', 'vssc'].includes(productId) && tenantId) {
      searchParams.append('tenantId', tenantId);
    }
  }
  return `${BASE_URL}/api/environments/${environmentId}/logs/delete?${searchParams.toString()}`;
};

export const DOWNLOAD_PRODUCT_LOGS_URL = (
  environmentId: string,
  productId: string,
  tenantId?: string
) => {
  const searchParams = new URLSearchParams();
  if (['vro', 'vssc'].includes(productId) && tenantId) {
    searchParams.append('tenantId', tenantId);
  }
  return `${BASE_URL}/api/environments/${environmentId}/products/${productId}/logs?${searchParams.toString()}`;
};

export const EXPORT_CONFIGURATION_URL = (environmentId: string, type: string) =>
  `${BASE_URL}/api/environments/${environmentId}/configuration?type=${type}`;

export const EXPORT_PRODUCT_CONFIGURATION_URL = (
  environmentId: string,
  productId: string,
  type: string,
  tenantId?: string
) => {
  const url = `${BASE_URL}/api/environments/${environmentId}/products/${productId}/configuration?`;
  const searchParams = new URLSearchParams();
  if (['vro', 'vssc'].includes(productId) && tenantId) {
    searchParams.append('type', type);
    searchParams.append('tenantId', tenantId);
    return `${url}${searchParams.toString()}`;
  } else {
    searchParams.append('type', type);
    return `${url}${searchParams.toString()}`;
  }
};

export const TRIGGER_ENVIRONMENT_INVENTORY_SYNC_URL = (environmentId: string) =>
  `${BASE_URL}/api/environments/${environmentId}/inventorysync`;

export const TOGGLE_HEALTH_URL = (environmentId: string, toggle: string) =>
  `${BASE_URL}/api/environments/${environmentId}/healthCheckToggle?toggle=${toggle}`;

export const GET_PRODUCT_ACTION_METADATA_URL = (
  product: string,
  version: string,
  action: string
) =>
  `${BASE_URL}/api/uimetadata/products/${product}/version/${version}/action/${action}`;

export const GET_ENVIRONMENT_VMS_FOR_DELETE_URL = (
  environmentId: string,
  deleteWindowsVMs: boolean
) =>
  `${BASE_URL}/api/environments/${environmentId}/delete?deleteWindowsVMs=${deleteWindowsVMs}`;

export const GET_PRODUCT_VMS_FOR_DELETE_URL = (
  environmentId: string,
  productId: string,
  deleteWindowsVMs: boolean
) =>
  `${BASE_URL}/api/environments/${environmentId}/products/${productId}/delete?deleteWindowsVMs=${deleteWindowsVMs}`;

export const GET_PRODUCT_INTEGRATIONS_URL = (
  environmentId: string,
  productId: string,
  tenantId?: string
) => {
  const searchParams = new URLSearchParams();
  if (['vro', 'vssc'].includes(productId) && tenantId) {
    searchParams.append('tenantId', tenantId);
  }

  return `${BASE_URL}/api/environments/${environmentId}/products/${productId}/integration?${searchParams.toString()}`;
};

export const GET_ENVIRONMENT_ACTIVE_REQUESTS_URL = (environmentId: string) =>
  `${REQUEST_BASE_URL}/api/requests/statusInProgress?requestSource=${environmentId}`;

export const DELETE_ENVIRONMENT_URL = (environmentId: string) =>
  `${BASE_URL}/api/environments/${environmentId}/delete`;

export const DELETE_PRODUCT_URL = (
  environmentId: string,
  productId: string,
  tenantId?: string
) => {
  const searchParams = new URLSearchParams();
  if (['vro', 'vssc'].includes(productId) && tenantId) {
    searchParams.append('tenantId', tenantId);
  }
  return `${BASE_URL}/api/environments/${environmentId}/products/${productId}/delete?${searchParams.toString()}`;
};

export const GET_AVAILABLE_PRODUCT_PATCHES_URL = (
  product: string,
  version: string,
  environmentId?: string
) => {
  if (environmentId) {
    return `${BASE_URL}/api/settings/patchsetting?productId=${product}&productVersion=${version}&availability=DOWNLOADED&environmentId=${environmentId}`;
  }
  return `${BASE_URL}/api/settings/patchsetting?productId=${product}&productVersion=${version}&availability=DOWNLOADED`;
};

export const SUBMIT_PATCH_REQUEST_URL = (
  environmentId: string,
  productId: string,
  patchId: string,
  prevalidate?: boolean,
  tenantId?: string
) => {
  let uri = `${BASE_URL}/api/environments/${environmentId}/products/${productId}/patch/${patchId}${
    prevalidate ? '/prevalidate' : ''
  }`;
  if (productId === 'vro' && tenantId) {
    uri += `?tenantId=${tenantId}`;
  }
  return uri;
};

export const SUBMIT_PRODUCT_ACTION_URL = (
  environmentId: string,
  productId: string,
  action: string,
  tenantId?: string
) => {
  const searchParams = new URLSearchParams();
  if (['vro', 'vssc'].includes(productId) && tenantId) {
    searchParams.append('tenantId', tenantId);
  }
  return `${BASE_URL}/api/environments/${environmentId}/products/${productId}/${action}?${searchParams.toString()}`;
};

export const MONITOR_VRA_WITH_VROPS_URL = (environmentId: string) =>
  `${BASE_URL}/api/environments/${environmentId}/monitorvRAwithvROPS`;

export const CONFIGURE_VROPS_AS_WLP_URL = (environmentId: string) =>
  `${BASE_URL}/api/environments/${environmentId}/configurevROPSAsWLPEndpoint`;

export const GET_SCALEOUT_VALIDATION_URL = `${BASE_URL}/api/environments/product/scaleout/validate`;

export const GET_PRECHECK_VALIDATIONS_URL = (requestId: string) =>
  `${REQUEST_BASE_URL}/api/prevalidationreport?requestId=${requestId}`;

export const RUN_PRECHECK_VALIDATIONS_URL = `${BASE_URL}/api/environments/prevalidate`;

export const UPGRADE_PRODUCT_URL = `${BASE_URL}/api/environments/upgrade`;

export const GET_AVAILABLE_UPGRADE_VERSIONS_URL = `${BASE_URL}/api/environments/upgrade/version`;

export const RUN_PRECHECK_UPGRADE_URL = `${BASE_URL}/api/environments/upgrade/prevalidate`;

export const GET_TARGET_VERSIONS_URL = `${BASE_URL}/api/v2/getTargetVersions`;

export const FIND_UPGRADE_PATH_URL = `${BASE_URL}/api/v2/findUpgradePath`;

export const RETRIEVE_VRA_UPGRADE_PLAN_URL = (environmentId: string) =>
  `${BASE_URL}/api/v2/environments/${environmentId}/products/vra/retrieveVraUpgradePlan`;

export const APUAT_VALIDATIONS_URL = (environmentId: string, version: string) =>
  `${BASE_URL}/api/environments/${environmentId}/upgradeVersion/${version}/vropsapuat`;

export const GET_UPGRADE_STATE_URL = (requestId: string) =>
  `${BASE_URL}/api/environments/upgrade/${requestId}/ui`;

export const VIDM_CLUSTER_AUTO_RECOVERY_URL = (
  environmentId: string,
  productId: string,
  enable: boolean
) =>
  `${BASE_URL}/api/environments/${environmentId}/products/${productId}/vidmClusterAutoRecovery?enable=${enable}`;

export const GET_UPGRADE_LCM_REPOSITORY_URL = (
  product: string,
  version: string
) => `${BASE_URL}/api/products/${product}/version/${version}/lcmrepositoryurl`;

export const GET_ABXCLOUDPROXY_UPGRADE_VERSION_URL = (environmentId: string) =>
  `${BASE_URL}/api/environments/${environmentId}/products/abxcloudproxy/getUpgradeVersion`;

export const GET_COMPATIBILITY_MATRIX = (product: string, version: string) =>
  `${BASE_URL}/api/products/${product}/version/${version}/interop`;

export const GET_PRODUCTS_INTEROP_MATRIX = `${BASE_URL}/api/products/interop`;

export const RUN_PRECHECK_VALIDATIONS_AND_DEPLOY_WINDOWS_URL = `${BASE_URL}/api/environments/prevalidateandinstallwindows`;

export const GET_PRODUCT_VERSIONS_URL = `${BASE_URL}/api/policy/products/version`;

export const GET_MANUAL_VALIDATIONS_URL = `${BASE_URL}/api/products/manualprecheck`;

export const GET_DATA_SOURCE_GROUPS_URL = (version: string) =>
  `/mocks/data-source-groups/${version}/spec.json`;

export const GET_DATA_SOURCES_META_DATA_URL = (version: string) =>
  `${BASE_URL}/api/uimetadata/products/vrni/${version}/datasource`;

export const ADD_DATA_SOURCES_URL = (
  environmentId: string,
  productId: string
) =>
  `${BASE_URL}/api/environments/${environmentId}/products/${productId}/adddatasource`;

export const UPDATE_NODE_PASSWORD_URL = (
  environmentId: string,
  productId: string,
  nodeType: string,
  tenantId?: string
) => {
  const searchParams = new URLSearchParams();
  if (['vro', 'vssc'].includes(productId) && tenantId) {
    searchParams.append('tenantId', tenantId);
  }
  return `${BASE_URL}/api/environments/${environmentId}/products/${productId}/node/${nodeType}?${searchParams.toString()}`;
};

export const UPDATE_VIDM_NODE_SSHUSER_PASSWORD_URL = (
  environmentId: string,
  productId: string,
  nodeType: string
) =>
  `${BASE_URL}/api/environments/${environmentId}/products/${productId}/node/${nodeType}/vidm/updatevidmsshuserpassword`;

export const RETRUST_VIDM_WITH_PRODUCT_URL = (
  environmentId: string,
  productId: string
) =>
  `${BASE_URL}/api/environments/${environmentId}/products/${productId}/productVidmRetrust`;

export const VIDM_INTEGRATION_WITH_VSSC_URL = (
  environmentId: string,
  tenantId: string
) =>
  `${BASE_URL}/api/environments/${environmentId}/products/vssc/integratevidm?tenantId=${tenantId}`;

export const RETRUST_PRODUCT_WITH_LOAD_BALANCER_URL = (
  environmentId: string,
  productId: string,
  tenantId?: string
) => {
  let url = `${BASE_URL}/api/environments/${environmentId}/products/${productId}/retrustLoadBalancerCertificate`;
  if (productId === 'vro' && tenantId) {
    const searchParams = new URLSearchParams();
    searchParams.set('tenantId', tenantId);
    url += '?' + searchParams.toString();
  }
  return url;
};

export const GRACEFUL_PRODUCT_SHUTDOWN_URL = (
  environmentId: string,
  productId: string
) =>
  `${BASE_URL}/api/environments/${environmentId}/products/${productId}/shutdown`;

export const GRACEFUL_PRODUCT_POWER_ON_URL = (
  environmentId: string,
  productId: string,
  rebootNodes?: boolean
) => {
  let url = `${BASE_URL}/api/environments/${environmentId}/products/${productId}/powerOn`;
  if (rebootNodes !== undefined && rebootNodes !== null) {
    url += `?performRebootIfRequired=${rebootNodes}`;
  }
  return url;
};

export const RE_REGISTER_WITH_IDENTITY_MANAGER_URL = (
  environmentId: string,
  productId: string
) =>
  `${BASE_URL}/api/environments/${environmentId}/products/${productId}/productVidmReregister`;

const getProductSnapshotBaseUrl = (
  environmentId: string,
  productId: string,
  tenantId: string
) => {
  const searchParams = new URLSearchParams();
  if (['vro', 'vssc'].includes(productId) && tenantId) {
    searchParams.append('tenantId', tenantId);
  }

  return {
    baseUrl: `${BASE_URL}/api/environments/${environmentId}/products/${productId}/snapshot/inventory`,
    urlSearchParams: `?${searchParams.toString()}`
  };
};

export const PRODUCT_SNAPSHOT_URL = (
  environmentId: string,
  productId: string,
  tenantId: string
) => {
  const { baseUrl, urlSearchParams } = getProductSnapshotBaseUrl(
    environmentId,
    productId,
    tenantId
  );
  return `${baseUrl}${urlSearchParams}`;
};

export const PRODUCT_SNAPSHOT_PRE_CHECK_URL = (
  environmentId: string,
  productId: string,
  tenantId: string
) => {
  const { baseUrl, urlSearchParams } = getProductSnapshotBaseUrl(
    environmentId,
    productId,
    tenantId
  );
  return `${baseUrl}/prevalidate${urlSearchParams}`;
};

export const PRODUCT_SNAPSHOT_REVERT_PRE_CHECK_URL = (
  environmentId: string,
  productId: string,
  tenantId: string
) => {
  const { baseUrl, urlSearchParams } = getProductSnapshotBaseUrl(
    environmentId,
    productId,
    tenantId
  );
  return `${baseUrl}/revert/prevalidate${urlSearchParams}`;
};

export const REVERT_TO_PRODUCT_SNAPSHOT_URL = (
  environmentId: string,
  productId: string,
  tenantId: string
) => {
  const { baseUrl, urlSearchParams } = getProductSnapshotBaseUrl(
    environmentId,
    productId,
    tenantId
  );
  return `${baseUrl}/revert${urlSearchParams}`;
};

export const REVERT_TO_PRODUCT_NODES_SNAPSHOT_URL = (
  environmentId: string,
  productId: string,
  tenantId: string
) => {
  const { baseUrl, urlSearchParams } = getProductSnapshotBaseUrl(
    environmentId,
    productId,
    tenantId
  );
  return `${baseUrl}/nodes/revert${
    productId === 'vra' ? '/vra' : ''
  }${urlSearchParams}`;
};

export const GET_AVAILABLE_TENANTS_URL = (
  environmentId: string,
  productId: string
) =>
  `${BASE_URL}/api/environments/${environmentId}/products/${productId}/getTenants`;

export const CREATE_LOCKER_REFERENCES_FROM_JSON_URL = `${BASE_URL}/api/environments/createLockerReferences`;

export const GET_ABXCLOUD_PROXY_UPGRADE_VERSION_DETAILS_URL = (
  requestId: string
) => `${REQUEST_BASE_URL}/api/v2/requests/${requestId}`;
